import { isNullOrUndefinedOrEmpty } from "rewire-common";

export function capitalize(word: string): string {
  if (!(word?.length)) return '';

  return `${word[0].toUpperCase()}${word.substring(1)}`;
}

export function getInitials(words: string, maxInitials: number = 2): string | undefined {
  if (isNullOrUndefinedOrEmpty(words)) {
    return undefined;
  }
  let initials   = '';
  const wordsArr = words.split(' ');
  for (let i = 0; i < wordsArr.length && initials.length < maxInitials; i++) {
    const w = wordsArr[i];
    initials += w.charAt(0).toUpperCase();
  }

  return initials;
}
